import React, { Suspense } from 'react'
import { render } from 'react-dom'
import { store } from './redux/Store'
import { Provider } from 'react-redux'
import client from './apollo/client'
import { ApolloProvider } from '@apollo/client'
import { BrowserRouter as Router } from 'react-router-dom'
import Spinner from './Components/Spinner'

import 'semantic-ui-less/semantic.less'
import './index.css'
import App from './App'
import * as serviceWorkerRegistration from './serviceWorkerRegistration'
import reportWebVitals from './reportWebVitals'
import { ThemeProvider } from '@mui/material'
import MuiTheme from './Components/SGC/MuiTheme'

render(
  <ApolloProvider client={client}>
    <meta name='viewport' content='width=device-width, initial-scale=1.0' />
    <Provider store={store}>
      <Suspense fallback={<Spinner />}>
        <Router>
          <ThemeProvider theme={MuiTheme}>
            <App />
          </ThemeProvider>
        </Router>
      </Suspense>
    </Provider>
  </ApolloProvider>
  ,
  document.getElementById('root')
)

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://cra.link/PWA
serviceWorkerRegistration.unregister()

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
